import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/ade`;
const http = axios.create({ baseURL: API, withCredentials: true });

export const api = {
  contacts: () => http.get("/contacts").then((r) => r.data),
  createContact: (data) => http.post("/contacts", data).then((r) => r.data),
  updateContact: (id, data) => http.put(`/contacts/${id}`, data).then((r) => r.data),
  deleteContact: (id) => http.delete(`/contacts/${id}`).then((r) => r.data),
  reset: () => http.post("/reset").then((r) => r.data),
  templates: () => http.get("/templates").then((r) => r.data),
  assets: () => http.get("/assets").then((r) => r.data),
  updateAsset: (id, data) => http.put(`/assets/${id}`, data).then((r) => r.data),
  actions: () => http.get("/actions").then((r) => r.data),
  updateAction: (id, done) => http.put(`/actions/${id}`, { done }).then((r) => r.data),
  playbook: () => http.get("/playbook").then((r) => r.data),
  stats: () => http.get("/stats").then((r) => r.data),
  tracks: () => http.get("/tracks").then((r) => r.data),
  scoring: () => http.get("/scoring").then((r) => r.data),
  reminders: (today) => http.get("/reminders", { params: today ? { today } : {} }).then((r) => r.data),
  exportXlsx: () => http.get("/export/xlsx", { responseType: "blob" }).then((r) => r.data),
  contactDraftHtml: (id) => http.get(`/contacts/${id}/draft-html`).then((r) => r.data),
  gmailStatus: () => http.get("/gmail/status").then((r) => r.data),
  gmailConnectUrl: () => axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/oauth/gmail/start`, { withCredentials: true, params: { return_to: "/ade-outreach" } }).then((r) => r.data),
  gmailDisconnect: () => http.post("/gmail/disconnect").then((r) => r.data),
  gmailCreateDrafts: (contact_ids, force = false) => http.post("/gmail/drafts", { contact_ids: contact_ids || null, force }).then((r) => r.data),
  gmailSyncReplies: () => http.post("/gmail/sync-replies").then((r) => r.data),
  gmailReplies: () => http.get("/gmail/replies").then((r) => r.data),
  gmailSendDigest: () => http.post("/gmail/digest/send").then((r) => r.data),
  parseMeetingDate: (value) => http.get("/gmail/parse-date", { params: { value } }).then((r) => r.data),
  gmailCalendarSync: () => http.post("/gmail/calendar/sync").then((r) => r.data),
  gmailImportScan: () => http.post("/gmail/import-demos/scan", {}, { timeout: 180000 }).then((r) => r.data),
  gmailImportConfirm: (candidates) => http.post("/gmail/import-demos/confirm", { candidates }).then((r) => r.data),
  gmailDraftFollowUps: () => http.post("/gmail/follow-ups").then((r) => r.data),
};
